import { Injectable } from '@angular/core';
import { clientDetection } from '../globalFunctions/globalFunctions';
import { Environment } from '../enums/environment.enum';

@Injectable({ providedIn: 'root' })
export class ClientContextService {
    public readonly clientCode: string;
    public readonly cdnEnvironment: Environment;

    constructor() {
        // Get the host and environment so we can find the CDN environment
        const host: string = globalThis.location.hostname.toLowerCase();
        const environment: Environment = this.detectEnvironmentFromHost(host);

        // Set the client code and CDN environment in order pull the correct branding
        this.clientCode = clientDetection();
        this.cdnEnvironment = this.setCdnEnvironmentFromMap(environment);
    }

    /** Detects which environment we are running in based on hostname conventions. */
    private readonly detectEnvironmentFromHost = (host: string): Environment => {
        if (host.includes('localhost') || host.endsWith('.localhost')) {
            return Environment.Local;
        }

        // Treat all test pipelines as "Test" (test2, test6, etc.)
        // Treat *-pwadev* hosts as "Test" (e.g., client-pwadev)
        if (/test\d+/.test(host) || /-pwadev/.test(host)) {
            return Environment.Test;
        }

        if (host.includes('uat')) {
            return Environment.UAT;
        }

        if (host.includes('staging')) {
            return Environment.Staging;
        }

        return Environment.Prod;
    };

    /**
     * Maps the runtime environment into the CDN environment segment.
     * We map Local -> UAT so local development can still load shared hosted assets.
     */
    private readonly setCdnEnvironmentFromMap = (environment: Environment): Environment => {
        return environment === Environment.Local ? Environment.UAT : environment;
    };
}
